import i18n from '@/locales/index'
import { getWhiteListUserPermissions, getInviterUuid } from '@/api'
import * as $http from '@/axios'
import { setToken, setRefreshToken, removeToken } from '@/utils/auth'
import Message from '@/plugins/message'
import { MessageBox } from 'element-ui'
import IM from '@/plugins/im'
import util from '@/utils/util'
import { adjust_report } from '@/utils/adjust'
import MyLog from '@/utils/my-log';

const isProd = process.env.VUE_APP_ENV === 'production'

const state = {
  token: null,
  refreshToken: null,
  userInfo: null,
  accountInfo: {},
  masterInfo: {},
  adminUuid: isProd ? '1896455' : '237731', // 管理员账号用於動態公告通知
  systemUuid: isProd ? ['1896455', '2084313', '2044343'] : ['237731', '237720', '301570'], // 官方帳號
  abTest: {}, // abTest
  showNewerRewardCheckTip: false,
  showAdBox: false,
  lockBodyScroll: false,
  whiteListUserPermissions: {},
  avatarBorder: null,
  avatarLevel: null,
  myGames: [],
  allGames: {},
  showNewerReward: true, // 新版通用紅包模板
  newDiscount: null, // 新获取的红包信息
  viewMasterInfo: {
    uuid: '',
    strongest: {},
  }, // 正在浏览的用户信息
  loadingViewMasterInfo: false, // 是否在获取浏览的用户信息
  redCircleInfo: {}, // 红点信息
  inviterUuid: '',
  quickOrderSkills: [], // 允許極速約單的技能列表
  quickOrderLegalTimes: {},
  hasFeedFollow: 0, // 是否有追踪人动态变化
  allGameCustomList: [],
  region:'US', //地区
  aliasList: null, //别名列表
}

const mutations = {
  SET_LOGIN: (state, { data, isSaveToken = null }) => {
    setToken(data.accessToken, {
      expires: isSaveToken ? 365 : 0.125
    })
    setRefreshToken(data.refreshToken, {
      expires: isSaveToken ? 365 : 0.125
    })
    state.token = data.accessToken
    state.userInfo = data
  },
  SET_TOKEN: (state, { token, refreshToken }) => {
    state.token = token
    state.refreshToken = refreshToken
  },
  SET_USER_INFO: (state, payload) => {
    state.userInfo = payload;
    if(payload) {
      MyLog.setUser({
        id:payload.uuid,
        name: payload.nickname,
      })
    }
  },
  SET_USER_ACCOUNT: (state, payload) => {
    state.accountInfo = payload
  },
  SET_MASTER_INFO: (state, data) => {
    state.masterInfo = data
  },
  SET_AB_TEST: (state, abTest) => {
    if (util) {
      abTest.newPlayerDetail = 'A'
    } else {
      abTest.newPlayerDetail = 'B'
    }
    state.abTest = abTest
  },
  SHOW_NEWER_REWARD: (state, payload) => {
    state.showNewerReward = payload
  },
  SHOW_NEWER_REWARD_CHECK_TIP: (state, payload) => {
    state.showNewerRewardCheckTip = payload
  },
  TOGGLE_AD_BOX: (state, payload) => {
    state.showAdBox = payload
  },
  LOCK_BODY_SCROLL: (state, payload) => {
    state.lockBodyScroll = payload
  },
  SET_WHITE_LIST_PERMISSIONS: (state, payload) => {
    state.whiteListUserPermissions = payload
  },
  SET_AVATAR_GUARD: (state, payload) => {
    state.avatarBorder = payload
  },
  SET_AVATAR_LEVEL: (state, payload) => {
    state.avatarLevel = payload
  },
  SET_MY_GAMES: (state, list) => {
    state.myGames = list
  },
  SET_ALL_GAMES: (state, obj) => {
    state.allGames = obj
  },
  SET_HOT_GAMES: (state, obj) => {
    state.allGameCustomList = obj
  },
  SET_NEW_DISCOUNT: (state, newDiscount) => {
    state.newDiscount = newDiscount
  },
  SET_VIEW_MASTER_INFO: (state, payload) => {
    state.viewMasterInfo = payload
  },
  SET_LOADING_VIEW_MASTER_INFO: (state, payload) => {
    state.loadingViewMasterInfo = payload
  },
  SET_RED_CIRCLE: (state, payload) => {
    state.redCircleInfo = payload
  },
  GET_INVITER_UUID: (state, payload) =>{
    state.inviterUuid = payload
  },
  SET_QUICK_ORDER_SKILLS: (state, list) => {
    state.quickOrderSkills = list
  },
  SET_QUICK_ORDER_LEGAL_TIMES: (state, payload) => {
    state.quickOrderLegalTimes = payload
  },
  SET_FEED_FOLLOW: (state, payload) => {
    state.hasFeedFollow = payload
  },
  SET_REGION: (state, payload) => {
    state.region = payload
  },
  SET_ALIAS_LIST: (state, payload) => {
    state.aliasList = payload
  }
}

const couponPromise = {
  p: null,
  resolve: () => {},
  reject: () => {},
}

const actions = {
  updateFeedFollow({ commit }, payload) {
    commit('SET_FEED_FOLLOW', payload)
  },
  login({ dispatch, commit }, payload) {
    const {
      phoneNumber, 
      verifyCode,
      keyUuid,
      isSaveToken,
      // isHome,
      // brandSocialTest,
      // brandGamingTest,
      // isBanner,
      inviterUnique,
      hasInvitedFive,
      signUpUniqueCode
    } = payload
    return new Promise((resolve, reject) => {
      $http.post('/user/telephone/login', { phoneNumber, verifyCode, keyUuid, inviterUnique, hasInvitedFive, signUpUniqueCode }).then(response => {
        const { data } = response
        if (data.userDeleteStatus === "DeleteReady") {
          MessageBox.confirm(i18n.t('components_login_components_thirdpary_new_1089')).then(()=>{
            $http.get('/user/delete/cancel', { uuid: data.uuid }).then(()=>{
              setTimeout(() => {
                commit('SET_LOGIN', {
                  data,
                  isSaveToken
                })
                dispatch('showRedbagDialog', 'NEWCOMER_EXPERIENCE')
                dispatch('getWhiteListUser')
                dispatch('getUserAccount')
                IM.imSdkInit()
              }, 500);
            })
          })
          resolve()
          return
        } 
        commit('SET_LOGIN', {
          data,
          isSaveToken
        })
        dispatch('showRedbagDialog', 'NEWCOMER_EXPERIENCE')
        dispatch('getWhiteListUser')
        dispatch('getUserAccount')
        if (data.isNewRegistration) {
          try {
            getInviterUuid({ uuid: data.uuid }).then(({ inviteResp })=>{
              let inviterUnique = ''
              const str = sessionStorage.getItem('INVITE_UNIQUE')
              str && (inviterUnique = JSON.parse(str).inviterUnique)
              adjust_report('web_blac_catch', {
                localUnique: window.localStorage.getItem('CURRENT_UNIQUE'),
                sessionUnique: inviterUnique,
                inviteNum: window.localStorage.getItem('REGISTER_NUM_' + inviterUnique),
                inviterUuid: inviteResp && inviteResp.invitedUuid ? inviteResp.invitedUuid : 0,
                current_uuid: data.uuid,
              })
            })
          } catch (error) {
            console.log(error)
          }
          // window.gtag('request', 'register', data.uuid)
          if(!localStorage['REGISTER_NUM_'+inviterUnique]) {
            window.localStorage['REGISTER_NUM_'+inviterUnique] = 1
          } else {
            window.localStorage['REGISTER_NUM_'+inviterUnique] +=1
          }
          // 手机号注册成功人数埋点
          // const userInfo = store.getters.userInfo
          // window.gtag('event', userInfo ? userInfo.uuid : 0, {
          //   event_category: 'tel_registe_success',
          //   non_interaction: true
          // })
          // window.gtag('event', 'Request', {
          //   event_label: data.uuid,
          //   event_category: 'register',
          //   non_interaction: true
          // })
          adjust_report('login_page_btn_click', {
            source: 'phone'
          })
          window.fbq('track', 'CompleteRegistration')
          window.fbq('track', 'Lead')
        } else {
          adjust_report('login_success', {
            source: 'phone'
          })
        }
        IM.imSdkInit()
        resolve()
      }).catch(error => {
        if (error.code === 427) {
          Message({
            message: i18n.t('store_modules_app_1955'),
            type: 'error',
            duration: 3000
          })
        } else {
          const stringCode = error.code + ''
          const code = stringCode.charAt(0)
          if (code === '4' || code === '6') {
            Message({
              message: i18n.t('components_login_components_phone_login_1082'),
              type: 'error',
              duration: 3000
            })
          }
        }
      
        reject(error)
      })
    })
  },
  getUserInfo: ({ dispatch, commit }, payload) => {
    const isCreate = payload ? payload.isCreate : false
    if (isCreate) {
      if (state.userInfo) return Promise.resolve(state.userInfo)
      if (actions.getUserInfo.promise) return actions.getUserInfo.promise
    }
    const p = new Promise((resolve, reject) => {
      $http.get('/user/info').then(({ data }) => {
        commit('SET_USER_INFO', data)
        dispatch('setABTest')
        dispatch('getRedCircle')
        if (payload && payload.token) {
          commit('SET_TOKEN', payload)
          dispatch('getUserAccount')
          dispatch('getWhiteListUser')
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
    if (isCreate) {
      actions.getUserInfo.promise = p
    }
    return p
  },
  setUserInfo: ({ commit, dispatch }, { userInfo }) => {
    commit('SET_USER_INFO', userInfo)
    dispatch('setABTest')
    dispatch('getRedCircle')
  },
  setSomeUserInfo: ({ commit, state }, payload) => {
    if (!state.userInfo) return
    commit('SET_USER_INFO', Object.assign(state.userInfo, payload))
  },
  setABTest({ commit }) {
    $http.get('/ab/getAb').then(({ data }) => {
      commit('SET_AB_TEST', data)
    }).catch(e => {
      console.log(e)
    })
  },
  resetToken: ({ commit, dispatch }) => {
    return new Promise(resolve => {
      commit('SET_TOKEN', {
        token: '',
        refreshToken: ''
      })
      commit('SET_USER_INFO', null)
      commit('SET_USER_ACCOUNT', {})
      commit('SET_RED_CIRCLE', {})
      commit('SET_AB_TEST', {})
      removeToken()
      dispatch('getWhiteListUser')
      resolve()
    })
  },
  toggleNewerReward: ({ commit }, payload) => {
    commit('SHOW_NEWER_REWARD', payload)
  },
  toggleNewerRewardCheckTip: ({ commit }, payload) => {
    commit('SHOW_NEWER_REWARD_CHECK_TIP', payload)
  },
  toggleAdBox: ({ commit }, payload) => {
    commit('TOGGLE_AD_BOX', payload)
  },
  lockBodyScroll: ({ commit }, payload) => {
    commit('LOCK_BODY_SCROLL', payload)
  },
  changeUserInfo: ({ dispatch, commit }, payload) => {
    commit('SET_LOGIN', payload)
    dispatch('getWhiteListUser')
    dispatch('getUserAccount')
  },
  getRedCircle: ({ commit, state }) => {
    if (!state.userInfo) {
      commit('SET_RED_CIRCLE', {})
      return
    }
    return $http.get('/reddot/info').then(({ data }) => {
      commit('SET_RED_CIRCLE', data)
    })
  },
  setRedCircle: ({ commit, state }, payload) => {
    commit('SET_RED_CIRCLE', Object.assign(state.redCircleInfo, payload))
  },
  getWhiteListUser: ({ commit }) => {
    return new Promise((resolve, reject) => {
      getWhiteListUserPermissions().then(({ data }) => {
        if (data) {
          commit('SET_WHITE_LIST_PERMISSIONS', data)
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  getUserAccount: ({ commit }) => {
    return new Promise((resolve, reject) => {
      $http.get('/user/account').then(({ data }) => {
        if (data) {
          commit('SET_USER_ACCOUNT', data)
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(reject)
    })
  },
  getAvatarBorder: ({ commit }) => {
    return new Promise((resolve, reject) => {
      $http.get('/basic/config')
        .then(({
          data
        }) => {
          commit('SET_AVATAR_GUARD', data.giftLabelImage)
          commit('SET_AVATAR_LEVEL', data.userLevelImage)
          resolve(data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  getGamesList: ({ commit }) => {
    // 查询全部游戏列表&我感兴趣的游戏列表
    return new Promise(resolve => {
      $http.get('game/userCustom/get/v2').then(({ data }) => {
        const myGames = data.userCustomGames
        const allGames = data.allGames
        commit('SET_MY_GAMES', myGames)
        commit('SET_ALL_GAMES', allGames)
        commit('SET_HOT_GAMES', data.allGameList)
        resolve({ myGames, allGames })
      })
    })
  },
  closeNewerReward: ({ commit }) => {
    commit('SHOW_NEWER_REWARD', false)
  },
  showRedbagDialog: ({ dispatch }) => {
    dispatch('getUserAccount')
  },
  redbagDialog: (store, {
    success = true,
    result = {}
  }) => {
    if (success) {
      couponPromise.resolve(result)
    } else {
      couponPromise.reject(result)
    }
  },
  setMasterInfo ({ commit, state }) {
    return $http.get('master/detail', {
      uuid: state.userInfo.uuid
    }).then(({ data }) => {
      if (data) {
        commit('SET_MASTER_INFO', data)
      }
    })
  },
  // 獲取正在瀏覽的用戶信息
  getMasterInfo: ({ commit, state }, { uuid, unique }) => {
    if (!uuid && !unique) return
    if (uuid !== state.viewMasterInfo.uuid) {
      commit('SET_VIEW_MASTER_INFO', { strongest: {}, uuid })
      commit('SET_LOADING_VIEW_MASTER_INFO', true)
    }
    return new Promise((resolve, reject) => {
      if (!unique) {
        $http.get('master/detail', {
          uuid,
        }).then(({ data }) => {
          if (uuid !== state.viewMasterInfo.uuid) return
          commit('SET_LOADING_VIEW_MASTER_INFO', false)
          commit('SET_VIEW_MASTER_INFO', data)
          resolve(data)
        }).catch(err => {
          commit('SET_LOADING_VIEW_MASTER_INFO', false)
          reject(err)
        });
      } else {
        // 查看b端個人頁
        $http.get('inviterB/detail', {
          unique,
        }).then(({ data }) => {
          commit('SET_LOADING_VIEW_MASTER_INFO', false)
          commit('SET_VIEW_MASTER_INFO', data)
          resolve(data)
        })
      }
    })
  },
  // 更新正在瀏覽的用戶信息
  updateViewMasterInfo: ({ commit, state }) => {
    const { uuid } = state.viewMasterInfo
    if (!uuid) return
    return new Promise((resolve, reject) => {
      $http.get('master/detail', { uuid }).then(({ data }) => {
        commit('SET_VIEW_MASTER_INFO', data)
        resolve(data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  // 更新部分正在瀏覽的用戶信息
  updateSomeOfViewMasterInfo: ({ commit, state }, payload) => {
    if (!payload) return
    const { viewMasterInfo } = state
    for (let attr in payload) {
      viewMasterInfo[attr] = payload[attr]
    }
    commit('SET_VIEW_MASTER_INFO', viewMasterInfo)
  },
  // 设置正在瀏覽的用戶信息
  setViewMasterInfo: ({ commit }, payload) => {
    if (!payload) return
    commit('SET_VIEW_MASTER_INFO', payload)
  },
  // 極速約單
  getQuickOrderSkills: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      if (state.quickOrderSkills.length) {
        resolve(state.quickOrderSkills)
        return
      }
      $http.get('/game/list/quick/match').then(({ data }) => {
        if (data) {
          commit('SET_QUICK_ORDER_SKILLS', data)
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(reject)
    })
  },
  getQuickOrderLegalTime: ({ commit }) => {
    return new Promise((resolve, reject) => {
      $http.get('/match/quick/config').then(({ data }) => {
        if (data) {
          let start = (data.startTime + 8) % 24
          let end = (data.endTime + 8) % 24
          if (end === 0) {
            end = 24
          }
          let times = `${ start }:00~${ end < 6 ? '凌晨' : '' }${ end }:00`
          let timesShort = `${ start }:00~${ end }:00`
          if (start === end) {
            times = '00:00~24:00'
            timesShort = times
          }
          commit('SET_QUICK_ORDER_LEGAL_TIMES', {
            times,
            timesShort,
            isOpen: data.open
          })
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(reject)
    })
  },
  setRegion:({commit},{region}) => {
    commit('SET_REGION', region)
  },
  setAliasList({ commit }) {
    return new Promise((resolve) => {
      $http.get('/user/getAllAlias').then(({ data }) => {
        commit('SET_ALIAS_LIST', data);
        resolve()
      }).catch(()=>{
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}